import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import appReducers from '../../modules';
import marketReducer from './modules/market';

export default combineReducers({
	routing: routerReducer,
	form: formReducer,
	marketMain: marketReducer,
	...appReducers
});



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/reducer.js